/* @flow */
import * as React from 'react';
import type TypeForm from 'forms/_.extend';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Loading from 'components/Loading/Loading';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerLocation from 'views/ActionDrawer/components/ActionDrawerLocation/ActionDrawerLocation';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import { NumberedCarousel } from 'views/ActionDrawer/components/NumberedCarousel/index';

import SiteAddress from 'components/SiteAddress/SiteAddress';

// import styles from '../../../../ActionDrawer.module.scss';
import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  assetStore: Object,
  form: TypeForm,
};

@translate()
@inject('assetStore', 'accountStore')
@observer
export default class ChangeAssetsLocationsForm extends React.Component<*> {
  renderDetails() {
    const { t, assetStore }: TypeProps = this.props;

    let assetInfo: Array<*> = [
      ['Trading Account', assetStore.asset.account.name],
      ['Asset Number', assetStore.asset.asset_number],
      ['Manufacturer', assetStore.asset.manufacturer],
      ['Model', assetStore.asset.model],
      ['OEM Serial Number', assetStore.asset.serial_number],
      ['Rental Backfill', assetStore.asset.calibration_service?.is_rental_backfill ? 'Yes' : 'No'],
      ['Calibration Type', assetStore.asset.calibration_service?.type],
    ];

    return (
      <>
        <ActionDrawerBlock
          divider={true}
          gutters={true}
          heading={t('general:assets.labels.details')}
        >
          <ActionDrawerTable data={assetInfo} />
          <div className={styles['clearfix']} />
          <div className={styles['info-block']}>
            <h3>{t('general:assets.labels.current_location')}</h3>
            {assetStore.asset?.location ? (
              <SiteAddress {...assetStore.asset.location.site.address} />
            ) : (
              <ul>
                <li>{t('general:search_results.no_location_found')}</li>
              </ul>
            )}
          </div>
        </ActionDrawerBlock>
      </>
    );
  }

  renderCarousel() {
    const { t, assetStore } = this.props;

    return (
      <ActionDrawerBlock
        divider={false}
        gutters={true}
        heading={t('general:assets.labels.details')}
      >
        <NumberedCarousel>
          {assetStore.assets.map(assetItem => {
            let assetInfo: Array<*> = [
              ['Trading Account', assetItem.account.name],
              ['Asset Number', assetItem.asset_number],
              ['Manufacturer', assetItem.manufacturer],
              ['Model', assetItem.model],
              ['OEM Serial Number', assetItem.serial_number],
            ];

            return (
              <React.Fragment key={assetItem.id}>
                <ActionDrawerTable data={assetInfo} />
                <div className={styles['clearfix']} />
                <div className={styles['info-block']}>
                  <h3>{t('general:assets.labels.current_location')}</h3>
                  {assetItem.location ? (
                    <SiteAddress {...assetItem.location.site.address} />
                  ) : (
                    <ul>
                      <li>{t('general:search_results.no_location_found')}</li>
                    </ul>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </NumberedCarousel>
      </ActionDrawerBlock>
    );
  }
  render() {
    const { t, form, assetStore, renderMultiple }: TypeProps = this.props;

    if (assetStore.loadingAssets) {
      return <Loading />;
    }

    const accountId = assetStore.assets[0]?.account?.id;

    if (accountId) {
      return (
        <React.Fragment>
          <div className={styles['action-drawer-content']}>
            {renderMultiple ? this.renderCarousel() : this.renderDetails()}

            <ActionDrawerBlock gutters={true} heading={form.$('changeLocation').label}>
              <ActionDrawerLocation
                field={form.$('changeLocation.location')}
                accountId={accountId}
              />
            </ActionDrawerBlock>
          </div>

          <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.change_location')} />
        </React.Fragment>
      );
    }
  }
}
